import React, { useState, useEffect, useContext } from "react";
import axios from 'axios';
import {
  TextField,
  Grid,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  IconButton,
  Tooltip
} from "@material-ui/core";
import Alert from '@material-ui/lab/Alert';

import SearchIcon from '@material-ui/icons/Search';
import HowToRegIcon from '@material-ui/icons/HowToReg';

import { PageContext } from "../../../contexts/PageContext";
import { UserContext } from "../../../contexts/UserContext";

export default function CreditBankAustriaCustomerField(
	{
    fieldConfig,
    currentMetafields,
    setMetafieldsValues,
    resolvePlaceholders,
    credit
	}) {

  const [value, setValue] = useState(null);
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResult,setSearchResult] = useState(null);
  const pageContext = useContext(PageContext);
  const userContext = useContext(UserContext);

  useEffect(() => {
		const externalValue = 
				currentMetafields[0].meta_value
					? currentMetafields[0].meta_value
					: ""
			;
    if (externalValue !== value) {
      setValue(externalValue);
    }
  }, [currentMetafields]);

  useEffect(() => {
    if (value !== null) {
      const externalValue = 
          currentMetafields[0].meta_value
            ? currentMetafields[0].meta_value
            : ""
        ;
      if (externalValue !== value)
        setMetafieldsValues(currentMetafields, value);
    }
  }, [value]);
  
  useEffect(() => {
    if (open) {
      setSearchTerm(resolvePlaceholders("[__person1__nachname]"))
    }
  }, [open]);

  const searchCustomers = () => {
    setIsLoading(true);
    const options = {
			url: `${process.env.REACT_APP_API_SERVICE_URL}/channels/findcustomer/BANKAUSTRIA/${searchTerm}`,
      method: 'get',
      headers: userContext.getRequestAuthHeader()
		};
    axios(options)
			.then((res) => {
        setIsLoading(false);
        setSearchResult(res.data);
      })
			.catch((err) => {
				console.log(err);
				pageContext.setErrorMessage("Die Verbindung konnte nicht hergestellt werden!");
        setIsLoading(false);
			});
  }

  const loadCustomer = (searchResultIndex) => {
    setIsLoading(true);
    const options = {
			url: `${process.env.REACT_APP_API_SERVICE_URL}/channels/loadcustomer/BANKAUSTRIA`,
      method: 'put',
      data: {
				credit_id: credit.id,
				searchTerm: searchResult.searchTerm,
        searchResultIndex: searchResultIndex,
        personIndex: parseInt( fieldConfig.meta_key.substring(8,9) )
			},
      headers: userContext.getRequestAuthHeader()
		};
    axios(options)
			.then((res) => {
        setIsLoading(false);
        location.reload()
      })
			.catch((err) => {
				console.log(err);
				pageContext.setErrorMessage("Der Kunde konnte nicht geladen werden!");
        setIsLoading(false);
			});
  }


  const printSearchResults = () => {
    if( !searchResult )
      return <></>
    if (searchResult.success && searchResult.customers.length === 0)
      return <Alert severity="info">Mit deinem Suchbegriff konnte ich keine bestehenden Kunden finden.</Alert>
    if (!searchResult.success)
			return <Alert severity="error">{searchResult.message}</Alert>
				
    return <List>
        {searchResult.customers.map((customer,i)=>{
          if(customer.name)
            return <ListItem key={i}>
                <ListItemText primary={customer.name} secondary={customer.description?customer.description:""}/>
                <ListItemSecondaryAction>
                  <Tooltip title="Diesen Kunden verwenden">
                    <IconButton edge="end" onClick={()=>loadCustomer(i)}>
                      <HowToRegIcon />
                    </IconButton>
                  </Tooltip>
                </ListItemSecondaryAction>
              </ListItem>
        })}
      </List>
  }

  const validate = (newValue) => {
    let newError = null;
    
    setError(newError);
  }

	if (!fieldConfig )
		return null;	
	
  const inputProps = {};


  
  return (
    <>
      <TextField
        key={currentMetafields[0].id}
        fullWidth
        label={fieldConfig.label}
        type="text"
        helperText={error!==null ? error : ""}
        value={value ? value : ""}
        error={error!==null}
        onChange={(e) => {
          validate(e.target.value);
          setValue( e.target.value );
        }}
        onBlur={() => {
          // force rerender to make sure placeholders using the value of this field are updated
          setMetafieldsValues(currentMetafields, value, true);
        }}
        inputProps={inputProps}
      />
      <Button
        size="small"
        onClick={() => {
          setOpen(true);
        }}
        startIcon={<SearchIcon/>}
      >
        Bestehenden BankAustria Kunden suchen
      </Button>
      <Dialog onClose={()=>{setOpen(false)}} open={open}>
        <DialogTitle>Bestehenden Kunden suchen</DialogTitle>
        <DialogContent>
          <DialogContentText>Falls für den Kunden bereits einen Kreditantrag bei der Bank Austria existiert kannst du die bestehenden Daten laden.</DialogContentText>
          
          <Grid container spacing={2}>
            <Grid item>
              <Typography>Nachname:</Typography>
            </Grid>
            <Grid item>
              <TextField
                type="text"
                value={searchTerm ? searchTerm : ""}
                onChange={(e) => {
                  setSearchTerm( e.target.value );
                }}
                readOnly={isLoading}  
                size="small"
              />
            </Grid>
            <Grid item>
              <Button
                size="small"
                onClick={() => {
                  searchCustomers();
                }}
                startIcon={<SearchIcon/>}
                variant="contained"
                disabled={isLoading || searchTerm.length <= 2}
              >
                suchen
              </Button>
            </Grid>
          </Grid>
          {isLoading &&
            <DialogContentText>
              <LinearProgress color="secondary" />
              <Typography variant="overline">Verbinde mich mit FinOnline und suche nach Kunden, dauert ca 1 Minute...</Typography>
            </DialogContentText>
          }
          {printSearchResults()}
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{setOpen(false)}} color="primary">
            abbrechen
          </Button>
        </DialogActions>
      </Dialog>
    </>
	);
}
